(function () {
  'use strict';

  var INTRO_KEY = 'casento-intro-done';

  function shouldPlayIntro() {
    if (document.body.classList.contains('template-cart')) return false;
    if (/\/cart\/?$/i.test(window.location.pathname || '')) return false;
    try {
      if (sessionStorage.getItem(INTRO_KEY) === '1') return false;
    } catch (e) {}
    return true;
  }

  function markIntroDone() {
    try {
      sessionStorage.setItem(INTRO_KEY, '1');
    } catch (e) {}
  }

  function resolveIntroSrc(root) {
    var desktop = root.getAttribute('data-intro-desktop') || '';
    var mobile = root.getAttribute('data-intro-mobile') || '';
    if (window.matchMedia('(min-width: 992px)').matches) return desktop;
    return mobile || desktop;
  }

  function initIntroVideo() {
    var root = document.querySelector('[data-casento-intro-video]');
    if (!root) return;
    if (!shouldPlayIntro()) {
      root.classList.add('is-closed');
      root.setAttribute('hidden', '');
      return;
    }

    var gate = root.querySelector('[data-intro-gate]');
    var enterBtn = root.querySelector('[data-intro-enter]');
    var media = root.querySelector('video');
    var skipBtn = root.querySelector('[data-intro-skip]');
    if (!gate || !enterBtn || !media) return;

    var src = resolveIntroSrc(root);
    if (!src) {
      root.classList.add('is-closed');
      root.setAttribute('hidden', '');
      return;
    }

    if (!skipBtn) {
      skipBtn = document.createElement('button');
      skipBtn.type = 'button';
      skipBtn.className = 'casento-intro-video__skip';
      skipBtn.setAttribute('data-intro-skip', '');
      skipBtn.textContent = 'Přeskočit';
      skipBtn.hidden = true;
      root.appendChild(skipBtn);
    }

    var closed = false;
    var started = false;
    var fallbackTimer = null;

    function clearFallback() {
      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
    }

    function lockPage() {
      document.documentElement.classList.add('casento-intro-open', 'casento-intro-active');
      document.body.classList.add('casento-intro-open', 'casento-intro-active');
    }

    function unlockPage() {
      document.documentElement.classList.remove('casento-intro-open', 'casento-intro-active');
      document.body.classList.remove('casento-intro-open', 'casento-intro-active');
    }

    function closeIntro() {
      if (closed) return;
      closed = true;
      clearFallback();
      markIntroDone();
      try {
        media.pause();
        media.removeAttribute('src');
        media.load();
      } catch (e) {}
      root.classList.remove('is-active', 'is-playing');
      root.classList.add('is-closed');
      root.setAttribute('hidden', '');
      gate.hidden = false;
      media.hidden = true;
      skipBtn.hidden = true;
      unlockPage();
    }

    function openGate() {
      root.classList.remove('is-closed');
      root.removeAttribute('hidden');
      root.classList.add('is-active');
      gate.hidden = false;
      media.hidden = true;
      skipBtn.hidden = true;
      lockPage();
    }

    function startIntro() {
      if (closed || started) return;
      started = true;
      gate.hidden = true;
      media.hidden = false;
      skipBtn.hidden = false;
      root.classList.add('is-playing');

      media.muted = false;
      media.volume = 1;
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('webkit-playsinline', '');
      media.src = src;
      media.preload = 'auto';
      media.load();

      clearFallback();
      fallbackTimer = window.setTimeout(closeIntro, 22000);

      var playPromise = media.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          media.muted = true;
          media.play().catch(function () {
            closeIntro();
          });
        });
      }
    }

    media.addEventListener('ended', closeIntro);
    media.addEventListener('click', closeIntro);
    skipBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeIntro();
    });

    media.addEventListener(
      'error',
      function () {
        closeIntro();
      },
      { once: true }
    );

    enterBtn.addEventListener('click', function (e) {
      e.preventDefault();
      startIntro();
    });

    window.addEventListener('pageshow', function () {
      if (closed) unlockPage();
    });

    openGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntroVideo);
  } else {
    initIntroVideo();
  }
})();
